export class State {
    constructor(public id: number, 
                public countryid: number, 
                public stateName: string, 
                public stateAbbr: string) 
      { }
  }